module.exports = __webpack_public_path__ + "media/images/btn_icon_login-6554e86b78fe1da99aae8d79fbc04df1.png";